import React from 'react';
import lax from 'lax.js';
import Footer from '../Common/Footer';
import PonenciasCvs from '../VariosCongreso/PonenciasCvs';
import MesasRedondas from '../VariosCongreso/MesasRedondas'

 
class Ponentes extends React.Component {
    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }
    render(){
        return (
            <React.Fragment>
                <div className="page-title-area item-bg1">
                    <div className="container">
                        <h1>Ponentes</h1>
{/*                         <span>Este congreso es posible gracias al apoyo de nuestros patrocinadores.</span>
 */}                    </div>
                </div>

                <section className="partner-area ponentes ptb-120">
                    <div className="container">

                    <PonenciasCvs />
                    <MesasRedondas />

                    </div>
                </section>
                <Footer />
            </React.Fragment>
        );
    }
}
 
export default Ponentes;